import axios from 'axios'

export const httpRutoken = axios.create({
	baseURL: `/rutoken`,
})
